@import '../../../theme.scss';

verdocs-template-tags {
  font-family: $primary-font;

  span {
    margin: 0 4px;
    height: 28px;
    font-size: 12px;
    font-weight: 600;
    padding: 5px 12px 7px;
    border-radius: 5px;
    display: inline-block;
    box-sizing: border-box;
    text-transform: uppercase;
    color: $label-color;
    border: 1px solid $border-color;
    background-color: $container-bg;
  }
}
